import React from "react";
import { SKILLS as TECH_STACK } from "../data/profile";

export default function Skills() {
  const [isDark, setIsDark] = React.useState(false);

  const toggleTheme = () => {
    setIsDark(!isDark);
  };

  return (
    <section id="skills" className="section">
      <div className="container">
        <h2 style={{ color: "var(--text)" }}>Skills & Technologies</h2>
        <div
          className={`terminal skills-term ${isDark ? 'terminal-dark' : 'terminal-light'}`}
          role="region"
          aria-label="Skills terminal"
        >
          <div
            className="terminal-top"
            style={{ justifyContent: "space-between" }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <span className="dot red" />
              <span className="dot yellow" />
              <span className="dot green" />
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <span className="tv-title"> </span>
              <label className="theme-switch">
                <input
                  type="checkbox"
                  checked={isDark}
                  onChange={toggleTheme}
                  aria-label={`Switch to ${isDark ? 'light' : 'dark'} theme`}
                />
                <span className="theme-slider"></span>
              </label>
            </div>
          </div>
          <div className="terminal-body skills-grid-body">
            <div className="skills-grid" role="list" aria-label="skills list">
              {TECH_STACK.map((tech) => (
                <TechIcon key={tech.name} tech={tech} isDark={isDark} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

// Modern tech icon component with hover effects
function TechIcon({ tech, isDark }) {
  if (!tech) {
    return null;
  }

  return (
    <div
      className="tech-icon"
      title={tech.name}
      aria-label={tech.name}
      role="listitem"
      style={{ "--tech-color": tech.color }}
    >
      <img
        src={tech.icon}
        alt={tech.name}
        className="tech-icon-img"
        style={{
          filter: isDark ? 'drop-shadow(0 0 2px rgba(255, 255, 255, 0.9))' : 'none'
        }}
        onError={(e) => {
          if (e.target.src !== tech.icon) {
            return;
          }

          e.target.src = `https://via.placeholder.com/40x40/${tech.color.slice(
            1
          )}/ffffff?text=${tech.name.charAt(0)}`;
        }}
      />
      <div className="tech-label">{tech.name}</div>
    </div>
  );
}

